module.exports = {
    // basic
    'a-role-type': 'a role type',
    // raw
    // template
};
